module.exports = __webpack_public_path__ + "static/scale-model-of-memorial-park-in-athens-georgia-c60a80729b00d6d0fcea2a512612f148.png";